import { BillingMode } from '../../../../../services/exports/Constants';

export default {
  titles: {
    draft: 'Il tuo ordine (costo mensile)',
    main: 'Il tuo abbonamento',
    billing_settings: 'Impostazioni di fatturazione',
  },
  form: {
    billing_mode: {
      label: 'Modalità di fatturazione',
    },
    has_trial: {
      label: 'Aggiungi giorni di prova gratuiti',
    },
    trial_days: {
      label: 'Quanti giorni di prova devono esserci?',
      placeholder: '21',
      validation: {
        required: 'I giorni di prova sono obbligatori',
        min: '{{value}} è il valore minimo per i giorni di prova',
        max: '{{value}} è il valore massimo per i giorni di prova',
      },
    },
  },
  fields: {
    created_at: 'Creato il <strong>{{date}}</strong> da <strong>{{manager}}</strong>',
    updated_at: 'Ultimo aggiornamento il <strong>{{date}}</strong> da <strong>{{manager}}</strong>',
    trial_ends_at: 'In prova fino al <strong>{{date}}</strong>',
    trial_days:
      "Prova di {{trialDays}} giorni a partire dalla data di lancio; l'addebito avverrà al termine della prova",
    resumable_until: 'Ripristinabile fino al <strong>{{date}}</strong>',
    ended_at: 'Terminato il <strong>{{date}}</strong>',
    next_bill_at: 'Prossima fattura il <strong>{{date}}</strong>',
    product: 'Prodotto',
    quantity: 'Quantità',
    price: 'Prezzo netto',
    tax: 'Tassa',
    amount: 'Importo',
    net: 'Netto',
    tax_percentage: 'IVA {{rate}}%',
    total: 'Addebito totale mensile',
  },
  billing_modes: {
    [BillingMode.Stripe]: 'Addebito dal metodo di pagamento',
    [BillingMode.InternalInvoicing]: 'Addebito dalle vendite',
  },
  labels: {
    included: 'incluso',
    sales_based_discount:
      "Nel carrello è presente un articolo con prezzo variabile; il prezzo effettivo verrà calcolato alla creazione/aggiornamento dell'abbonamento in base alle vendite del mese precedente",
  },
  buttons: {
    edit: 'Modifica',
    cancel: 'Annulla',
    resume: 'Riprendi',
  },
  modals: {
    cancel_subscription: {
      title: "Annullare l'abbonamento di {{company}}?",
      description:
        "Questo annullerà l'abbonamento selezionato, incluso <strong>{{products}}</strong> (<strong>{{total}} importo totale</strong>). L'abbonamento potrà ancora essere ripristinato fino al <strong>{{billingAnchor}}</strong> se il cliente cambia idea. Se l'abbonamento non viene ripristinato entro tale data, sarà necessario crearne uno nuovo",
    },
    resume_subscription: {
      title: "Ripristinare l'abbonamento di {{company}}?",
      description:
        "Questo ripristinerà l'abbonamento selezionato, incluso <strong>{{products}}</strong>. Al ristorante verrà addebitato <strong>{{total}}</strong> ogni mese a partire dal <strong>{{billingAnchor}}</strong>",
    },
  },
  toasts: {
    cancel_subscription:
      "Per annullare il tuo abbonamento, contatta il tuo referente {{provider}} per telefono o e-mail. Il tuo referente annullerà immediatamente l'abbonamento per te.",
    failed_to_cancel_subscription:
      "Si è verificato un errore durante l'annullamento dell'abbonamento. Contatta il supporto tecnico",
    resume_subscription:
      "Per ripristinare il tuo abbonamento, contatta il tuo referente {{provider}} per telefono o e-mail. Il tuo referente ripristinerà immediatamente l'abbonamento per te.",
    failed_to_resume_subscription:
      "Si è verificato un errore durante il ripristino dell'abbonamento. Contatta il supporto tecnico",
  },
};
